"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const linkview_align_parser_1 = require("@linkview/linkview-align-parser");
const render_1 = require("./render");
const svgTemplates_1 = require("./svgTemplates");
const geneType = ['gene'];
const mRnaType = ['mrna'];
const exonType = ['exon'];
const utr3Type = ['three_prime_UTR', '3_UTR'];
const utr5Type = ['five_prime_UTR', '5_UTR'];
function parseAttributes(attr) {
    const res = {};
    if (!attr.endsWith(';'))
        attr += ';';
    let contentFlag = false;
    let lastPos = 0;
    for (let index = 0, len = attr.length; index < len; index++) {
        const char = attr[index];
        if (char === '"') {
            contentFlag = !contentFlag;
        }
        else if (char === ';' && !contentFlag) {
            const item = attr.slice(lastPos, index);
            let [key, value] = item.split('=');
            value = value ? value.trim().replace(/"/g, '') : '';
            res[key] = value;
            lastPos = index + 1;
        }
    }
    return res;
}
function parseGff(gffFile, ctgs) {
    const mRNAInfoMap = {};
    const ctg2MRNAInfos = {};
    const initMRNAInfoMap = (mRNAId) => {
        mRNAInfoMap[mRNAId] = {
            exons: [],
            UTR3s: [],
            UTR5s: [],
            pos: [-1, -1],
            parent: undefined,
            strand: '+',
        };
    };
    return (0, linkview_align_parser_1.eachLine)(gffFile, (line) => {
        if (line.startsWith('#') || line.trim() === '')
            return true;
        let [ctg, source, annoType, start, end, score, strand, phase, attrStr] = line.split('\t');
        if (!ctgs.has(ctg))
            return true;
        const attr = parseAttributes(attrStr);
        const annoId = attr.ID;
        annoType = annoType.toLowerCase();
        if (mRnaType.includes(annoType)) {
            if (!mRNAInfoMap[annoId]) {
                initMRNAInfoMap(annoId);
            }
            mRNAInfoMap[annoId].pos = [Number(start), Number(end)];
            mRNAInfoMap[annoId].parent = attr.Parent;
            mRNAInfoMap[annoId].strand = strand;
            if (!ctg2MRNAInfos[ctg])
                ctg2MRNAInfos[ctg] = [];
            ctg2MRNAInfos[ctg].push(mRNAInfoMap[annoId]);
        }
        else if (exonType.includes(annoType)) {
            const mRNAId = attr.Parent;
            if (!mRNAId)
                return true;
            if (!mRNAInfoMap[mRNAId])
                initMRNAInfoMap(annoId);
            mRNAInfoMap[mRNAId].exons.push([Number(start), Number(end)]);
        }
        else if (utr3Type.includes(annoType)) {
            const mRNAId = attr.Parent;
            if (!mRNAId)
                return true;
            if (!mRNAInfoMap[mRNAId])
                initMRNAInfoMap(annoId);
            mRNAInfoMap[mRNAId].UTR3s.push([Number(start), Number(end)]);
        }
        else if (utr5Type.includes(annoType)) {
            const mRNAId = attr.Parent;
            if (!mRNAId)
                return true;
            if (!mRNAInfoMap[mRNAId])
                initMRNAInfoMap(annoId);
            mRNAInfoMap[mRNAId].UTR5s.push([Number(start), Number(end)]);
        }
        return true;
    }).then(() => {
        return { mRNAInfoMap, ctg2MRNAInfos };
    });
}
function parseGffContent(gffContent, ctgs) {
    const mRNAInfoMap = {};
    const ctg2MRNAInfos = {};
    const initMRNAInfoMap = (mRNAId) => {
        mRNAInfoMap[mRNAId] = {
            exons: [],
            UTR3s: [],
            UTR5s: [],
            pos: [-1, -1],
            parent: undefined,
            strand: '+',
        };
    };
    const lines = gffContent.trim().split('\n');
    for (const line of lines) {
        if (line.startsWith('#') || line.trim() === '')
            continue;
        let [ctg, source, annoType, start, end, score, strand, phase, attrStr] = line.split('\t');
        if (!ctgs.has(ctg))
            continue;
        const attr = parseAttributes(attrStr);
        const annoId = attr.ID;
        annoType = annoType.toLowerCase();
        if (mRnaType.includes(annoType)) {
            if (!mRNAInfoMap[annoId]) {
                initMRNAInfoMap(annoId);
            }
            mRNAInfoMap[annoId].pos = [Number(start), Number(end)];
            mRNAInfoMap[annoId].parent = attr.Parent;
            mRNAInfoMap[annoId].strand = strand;
            if (!ctg2MRNAInfos[ctg])
                ctg2MRNAInfos[ctg] = [];
            ctg2MRNAInfos[ctg].push(mRNAInfoMap[annoId]);
        }
        else if (exonType.includes(annoType)) {
            const mRNAId = attr.Parent;
            if (!mRNAId)
                continue;
            if (!mRNAInfoMap[mRNAId])
                initMRNAInfoMap(annoId);
            mRNAInfoMap[mRNAId].exons.push([Number(start), Number(end)]);
        }
        else if (utr3Type.includes(annoType)) {
            const mRNAId = attr.Parent;
            if (!mRNAId)
                continue;
            if (!mRNAInfoMap[mRNAId])
                initMRNAInfoMap(annoId);
            mRNAInfoMap[mRNAId].UTR3s.push([Number(start), Number(end)]);
        }
        else if (utr5Type.includes(annoType)) {
            const mRNAId = attr.Parent;
            if (!mRNAId)
                continue;
            if (!mRNAInfoMap[mRNAId])
                initMRNAInfoMap(annoId);
            mRNAInfoMap[mRNAId].UTR5s.push([Number(start), Number(end)]);
        }
    }
    return { mRNAInfoMap, ctg2MRNAInfos };
}
function assignCtg2MRNAInfosSingle(target, source) {
    for (let ctg in source) {
        if (!(ctg in target)) {
            target[ctg] = source[ctg];
        }
        else {
            target[ctg].push(...source[ctg]);
        }
    }
}
function mRNAInfosDeOverlap(mRNAInfos) {
    mRNAInfos.sort((a, b) => a.pos[0] - b.pos[0]);
    let lastStart = 0, lastEnd = 0;
    for (let index = 0, count = mRNAInfos.length; index < count; index++) {
        const mRNAInfo = mRNAInfos[index];
        if (!mRNAInfo)
            continue;
        const [start, end] = mRNAInfo.pos;
        if ((0, linkview_align_parser_1.intersection)([lastStart, lastEnd], [start, end]).length !== 0) {
            mRNAInfos.splice(index, 1);
            index--;
            count--;
        }
        else {
            lastStart = start;
            lastEnd = end;
        }
    }
}
function renderExons(intervals, direction, layoutItem, className) {
    const svgContents = [];
    for (const [intervalStart, intervalEnd] of intervals) {
        const [xStart, yStart] = layoutItem.getSvgPos(intervalStart, 'top');
        const [xEnd] = layoutItem.getSvgPos(intervalEnd, 'top', true);
        const xMin = Math.min(xStart, xEnd);
        const xMax = Math.max(xStart, xEnd);
        const xMinMiddle = xMin + (xMax - xMin) * 0.2;
        const xMaxMiddle = xMin + (xMax - xMin) * 0.8;
        const yTop = yStart + layoutItem.svgHeight * 0.2;
        const yMiddle = yStart + layoutItem.svgHeight * 0.5;
        const yBottom = yStart + layoutItem.svgHeight * 0.8;
        const svgGeneExonPropsForward = {
            x1: xMin,
            y1: yTop,
            x2: xMin,
            y2: yBottom,
            x3: xMaxMiddle,
            y3: yBottom,
            x4: xMax,
            y4: yMiddle,
            x5: xMaxMiddle,
            y5: yTop,
            className,
        };
        const svgGeneExonPropsReverse = {
            x1: xMin,
            y1: yMiddle,
            x2: xMinMiddle,
            y2: yBottom,
            x3: xMax,
            y3: yBottom,
            x4: xMax,
            y4: yTop,
            x5: xMinMiddle,
            y5: yTop,
            className,
        };
        svgContents.push((0, render_1.renderItem)(svgTemplates_1.SVG_GENE_EXON, direction > 0 ? svgGeneExonPropsForward : svgGeneExonPropsReverse));
    }
    return svgContents;
}
function geneSvg() {
    return __awaiter(this, void 0, void 0, function* () {
        const options = this;
        const { layout, gff: gffs, gffContent } = options;
        const svgContents = [];
        const mRNAInfoMap = {};
        const ctg2MRNAInfos = {};
        const ctgs = new Set();
        layout.forEach(layoutLine => {
            layoutLine.forEach(layoutItem => {
                const { ctg } = layoutItem;
                ctgs.add(ctg);
            });
        });
        if (gffs) {
            for (let gff of gffs) {
                const { mRNAInfoMap: mRNAInfoMapSingle, ctg2MRNAInfos: ctg2MRNAInfosSingle } = yield parseGff(gff, ctgs);
                Object.assign(mRNAInfoMap, mRNAInfoMapSingle);
                assignCtg2MRNAInfosSingle(ctg2MRNAInfos, ctg2MRNAInfosSingle);
            }
        }
        else if (gffContent) {
            const { mRNAInfoMap: mRNAInfoMapSingle, ctg2MRNAInfos: ctg2MRNAInfosSingle } = parseGffContent(gffContent, ctgs);
            Object.assign(mRNAInfoMap, mRNAInfoMapSingle);
            assignCtg2MRNAInfosSingle(ctg2MRNAInfos, ctg2MRNAInfosSingle);
        }
        layout.forEach(layoutLine => {
            layoutLine.forEach(layoutItem => {
                const { ctg, start, end } = layoutItem;
                const min = Math.min(start, end);
                const max = Math.max(start, end);
                let mRNAInfos = ctg2MRNAInfos[ctg];
                if (!mRNAInfos)
                    return;
                mRNAInfos = mRNAInfos.filter(mRNAInfo => {
                    const [mRNAStart, mRNAEnd] = mRNAInfo.pos;
                    if (mRNAEnd < min || mRNAStart > max)
                        return false;
                    return true;
                });
                mRNAInfosDeOverlap(mRNAInfos);
                for (let mRNAInfo of mRNAInfos) {
                    const { exons, UTR3s, UTR5s, strand } = mRNAInfo;
                    const [mRNAStart, mRNAEnd] = mRNAInfo.pos;
                    const introns = (0, linkview_align_parser_1.complement)([mRNAStart, mRNAEnd], [...exons, ...UTR3s, ...UTR5s]);
                    let direction = 1;
                    if (strand === '-')
                        direction *= -1;
                    if (start < end)
                        direction *= -1;
                    svgContents.push(...renderExons(exons, direction, layoutItem, 'exon'));
                    svgContents.push(...renderExons(UTR3s, direction, layoutItem, 'UTR3'));
                    svgContents.push(...renderExons(UTR5s, direction, layoutItem, 'UTR5'));
                    for (const [intronStart, intronEnd] of introns) {
                        const [x1, y1] = layoutItem.getSvgPos(intronStart, 'top');
                        const [x2] = layoutItem.getSvgPos(intronEnd, 'top');
                        svgContents.push((0, render_1.renderItem)(svgTemplates_1.SVG_GENE_INTRON, {
                            x1,
                            x2,
                            y: y1 + layoutItem.svgHeight * 0.5,
                        }));
                    }
                }
            });
        });
        if (!options.svg_template)
            options.svg_template = [];
        options.svg_template.push({ content: svgContents });
        return options;
    });
}
exports.default = geneSvg;
